import { BlockComponentBaseProps } from '@api/types';
import { BlockContainer } from '@components/common/Container/BlockContainer';
import { BlockProperty } from '@components/edit-mode';
import { useScrollToHash } from '@hooks';
import { Box } from '@mui/material';
import { transformImagesInHtml } from '@utils/index';
import './RteBlock.css';

export type RteBlockProps = BlockComponentBaseProps & {
  title?: string;
  text?: string;
  fullscreen?: boolean;
  width?: string;
};

export const RteBlock = ({
  fullscreen,
  text = '',
  disableEditPanel = false,
  width = 'unset',
}: RteBlockProps) => {
  useScrollToHash(!!text);
  return (
    <BlockContainer fullscreen={fullscreen}>
      <Box maxWidth={width || 'unset'} className='html-wrapper rte-block centered'>
        <BlockProperty property='Text'>
          {text && <div dangerouslySetInnerHTML={{ __html: transformImagesInHtml(text) }} />}
        </BlockProperty>
      </Box>
    </BlockContainer>
  );
};
